import * as appsNoms from './appsnoms.js';
import * as appsNomsExtract from './appsnoms-extract.js';

export default {
    appsNoms,
    appsNomsExtract,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // appsNoms
    window.EQLAPP.APPSNOMS = window.EQLAPP.APPSNOMS || {};
    Object.entries(appsNoms).forEach(([key, value]) => {
        window.EQLAPP.APPSNOMS[key] = value;
    });

    // appsNomsExtract
    window.EQLAPP.APPSNOMSEXTRACT = window.EQLAPP.APPSNOMSEXTRACT || {};
    Object.entries(appsNomsExtract).forEach(([key, value]) => {
        window.EQLAPP.APPSNOMSEXTRACT[key] = value;
    });

}